import { createAction, props } from "@ngrx/store";
import { MaintenanceInfo } from './../states/maintenanceInfo.state';

export const LoadMaintenanceInfoSuccess = createAction(
  "[Maintenance Info] Load Maintenance Info Success",
  props<{ maintenanceInfo: MaintenanceInfo }>()
);
